import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import {User} from '../model/Entities/User';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {Customer} from '../model/Entities/Customer';
import {CustomerContactPerson} from '../model/Entities/CustomerContactPerson';

@Injectable()
export class CustomerContactPersonService extends ApiService<CustomerContactPerson> {

    protected apiUrl = 'api/contacts';  // URL to web api

    protected getObjectType(): any {
        return CustomerContactPerson;
    }
}



// WEBPACK FOOTER //
// /app/src/services/customer-contact-person.service.ts